export default {"src":"//tokenlon.im/_next/static/media/toggle-settings-to-set-pay-mode-zh.b8495c1b.gif","height":250,"width":600};